import React from "react";
import img from "./static/companylogo.png";

export default (props: any) => (
  <img src={img} {...props} style={{ width: 30, ...props.style }} />
);
